import { Service } from '@roc/feature-app-core';
import { PropertyLien } from '../components/lienPayoffReview/lienPayoffReviewCard';

const url = {
  GET_SCREEN_DATA: '/api/v1/doc-review/liens/getLienPayoffInfo',
  UPLOAD_LIEN_PAYOFF_FILE: '/api/v1/doc-review/liens/uploadLienPayoffFile',
  DOWNLOAD_LIEN_PAYOFF_FILE: '/api/v1/doc-review/liens/downloadLienPayoffFile',
  DELETE_PAYOFF: '/api/v1/doc-review/liens/deletePayoff',
  // Same lien CRUD endpoints Title Commitment's manual Add/Edit uses (libs/feature-lien) -
  // both features write to the same property_liens table, so there's one backend surface.
  SAVE_LIEN: '/api/v1/doc-review/liens/saveLien',
};

export class LienPayoffReviewService extends Service {
  getScreenData(loanId: number, propertyId?: number) {
    return this.get(url.GET_SCREEN_DATA, { loanId, propertyId });
  }

  uploadLienPayoffFile(
    file: File,
    propertyLienId: number,
    lienPayoffRecordId?: number
  ) {
    const formData = new FormData();
    formData.append('file', file);
    const query = new URLSearchParams();
    query.append('propertyLienId', String(propertyLienId));
    if (lienPayoffRecordId != null) {
      query.append('lienPayoffRecordId', String(lienPayoffRecordId));
    }
    return this.post(`${url.UPLOAD_LIEN_PAYOFF_FILE}?${query.toString()}`, formData);
  }

  downloadLienPayoffFile(lienPayoffRecordId: number) {
    return this.get(
      url.DOWNLOAD_LIEN_PAYOFF_FILE,
      { lienPayoffRecordId },
      { responseType: 'arraybuffer' }
    );
  }

  deletePayoff(propertyLienId: number) {
    return this.delete(url.DELETE_PAYOFF, { propertyLienId });
  }

  saveLien(lien: Partial<PropertyLien>) {
    return this.post(url.SAVE_LIEN, lien);
  }
}
